module.exports = __webpack_public_path__ + "static/media/hamburger-light.9712d98a.svg";